import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      // Sits level with the title's cap height rather than the row's centre, so it stays put
      // whether the row wraps to two lines or four.
      height: 20,
      justifyContent: 'center',
      marginRight: spacing(0.5),
      width: 20,
      '& svg': {
        fill: 'none',
        fontSize: 16,
      },
    },
  });
